import type { LandingTestimonialFields } from '@repo/api-contracts';
import { trpc } from '@/shared/api';
import { useLandingTestimonialUpload } from './use-landing-testimonial-upload';

interface UseAddLandingTestimonialOptions {
  readonly onSuccess?: () => void;
}

/** 사진을 올리고 글과 함께 목록 맨 뒤에 등록한다. */
export const useAddLandingTestimonial = ({ onSuccess }: UseAddLandingTestimonialOptions = {}) => {
  const uploader = useLandingTestimonialUpload();
  const mutation = trpc.landing.createTestimonial.useMutation({ onSuccess });

  /** 성공하면 true — 폼 모달을 닫는 데 쓴다. 실패 원인은 error 로 화면에 남는다. */
  const addItem = async (file: File, fields: LandingTestimonialFields): Promise<boolean> => {
    const imageKey = await uploader.upload(file);

    if (imageKey === null) {
      return false;
    }

    try {
      await mutation.mutateAsync({ ...fields, imageKey });
      return true;
    } catch {
      // 서버 거부 문구는 mutation.error 로 남아 모달에 보인다 — 여기서는 닫지 않을 신호만 준다.
      return false;
    }
  };

  return {
    addItem,
    isPending: uploader.isUploading || mutation.isPending,
    error: uploader.error ?? mutation.error?.message ?? null,
    /** 지난 업로드·서버 오류를 지운다 — 등록 모달을 새로 열 때 쓴다. */
    reset: () => {
      mutation.reset();
      uploader.clearError();
    },
  };
};
